module.exports = __webpack_public_path__ + "static/img/1-1.f4c6c33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-1.png
// module id = cYS8
// module chunks = 1